<template>
  <div v-if="signatories">
    <h4 v-if="!hideHeader" class="blue-grey--text text--darken-1 mt-1">Signatories</h4>
    <p class="text-left">
      <span v-for="(co, i) in signatories" :key="i">
        <span>
          <v-tooltip dark right>
            <template v-slot:activator="{ on, attrs }">
              <font-awesome-icon icon="signature" :color="co.signed ? 'green' : 'red'"
                v-bind="attrs" v-on="on" />
            </template>
            <span>{{ tooltipText(co.signed, co.signedByAdmin) }}</span>
          </v-tooltip>
        </span>
        {{ co.firstName }}
        {{ co.lastName }}
        <span v-if="co.memberId">(Member ID: {{ co.memberId.trim() }})</span>
        <br />
      </span>
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "SignatureStatusList",
  methods: {
    tooltipText(isSigned: boolean, isSignedByAdmin: boolean){
        if(isSigned) {
            if(isSignedByAdmin) {
                return "Signature received - signed by admin"
            }
            return "Signature received"
        }
        return "Signature has not been received"
      }
  },
  props: {
    hideHeader: { type: Boolean },
    signatories: { type: Array },
  },
});
</script>
